<xp-dialog *ngIf="visibleAddDriversToVhicle" class="assign-drivers-dialog">
  <xp-dialog-header class="vehicle-dialog-header" heading="Assign Drivers" (closeClick)="cancel()"></xp-dialog-header>

  <mat-card-content>
    <xp-loading *ngIf="isLoading" class="spinner-center" [diameter]="48"></xp-loading>

    <ng-container *ngIf="!isLoading">
      <div class="autocomplete-scroll-panel">
        <xp-search-field class="w-100 search-field"
                         placeholder="Search Driver"
                         [autocomplete]="riderAuto"
                         [(value)]="selectRiderInput"
                         (valueChange)="searchRiders({ query: $event })"></xp-search-field>
        <mat-autocomplete #riderAuto="matAutocomplete"
                          [displayWith]="displayRiderFn"
                          (optionSelected)="onSelectDriverEvent($event)">
          <mat-option *ngFor="let rider of riders" [value]="rider">
            <div class="flex align-items-center gap-2">
              <xp-avatar class="driver-option-image" [imageUrl]="rider.ImageUrl || 'Content/xpress-app/images/no-avatar.png'"></xp-avatar>
              <span>{{ displayRiderFn(rider) }}</span>
            </div>
          </mat-option>
          <mat-option *ngIf="!isSearching && (!riders || riders.length === 0)" disabled>
            No drivers found
          </mat-option>
        </mat-autocomplete>

        <div class="driver-hint" *ngIf="!selectRiders.length">
          Type to search, or click the field to pick from your linked drivers.
        </div>

        <mat-chip-set class="selected-drivers-chips mt-2">
          <mat-chip *ngFor="let rider of selectRiders"
                    (removed)="removeDriver(rider.riderId)"
                    class="driver-chip">
            <xp-avatar [imageUrl]="rider.imageUrl || 'Content/xpress-app/images/no-avatar.png'" class="driver-image mr-2"></xp-avatar>
            <span class="driver-username">{{rider.userName}}</span>
            <button matChipRemove>
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip>
        </mat-chip-set>
      </div>
    </ng-container>
  </mat-card-content>

  <mat-card-actions align="end" *ngIf="!isLoading">
    <button mat-stroked-button type="button" class="mr-2" (click)="cancel()">Cancel</button>
    <button mat-flat-button color="primary" type="button"
            [disabled]="selectRiders.length === 0"
            (click)="assignDrivers()">Assign Drivers</button>
  </mat-card-actions>
</xp-dialog>
